import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Button, DatePicker, Input, Select, Table } from "antd";
import config from "../../../config";
import authHeader from "../../Authentication/authHeader";
import SalesBillTemplate from "./SalesBillTemplate";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

export default function SalesList({ tabChange }) {
  dayjs.extend(utc);
  dayjs.extend(timezone);
  const TIMEZONE = "Asia/Dhaka";
  const { Option } = Select;
  const { Search } = Input;
  const { RangePicker } = DatePicker;
  const [invoiceLists, setInvoiceLists] = useState([]);
  const [salesLoading, setSalesLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [centerList, setCenterList] = useState([]);
  const [centerIds, setCenterIds] = useState([]);
  const [search, setSearch] = useState("");
  const [userProfile, setUserProfile] = useState(
    JSON.parse(localStorage.getItem("userProfile"))
  );
  const [selectedCenter, setSelectedCenter] = useState("");
  const [selectedDateRange, setSelectedDateRange] = useState([]);
  const [selectedType, setSalesSelectedType] = useState("");
  const [visible, setVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState({});

  const handleSalesDateRage = (value) => {
    setCurrentPage(1);
    if (Array.isArray(value) && value.length === 2 && value[0] && value[1]) {
      let startDate = dayjs.tz(value[0], TIMEZONE).startOf("day");
      let endDate = dayjs.tz(value[1], TIMEZONE).endOf("day");

      setSelectedDateRange([
        startDate.format("YYYY-MM-DDTHH:mm:ssZ"),
        endDate.format("YYYY-MM-DDTHH:mm:ssZ"),
      ]);
    } else {
      setSelectedDateRange(null);
    }
  };

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
  };
  const handleSearch = (value) => {
    setSearch(value);
  };
  const handleCenter = (value) => {
    setCurrentPage(1);
    setSelectedCenter(value);
  };
  const handleBill = (record) => {
    setSelectedRecord(record);
    setVisible(true);
  };
  const handleCancel = () => {
    setVisible(false);
  };

  const fetchData = async () => {
    try {
      setSalesLoading(true);
      const response = await axios.get(
        `${config.baseUrl}/inventory/full_sales_list/`,
        {
          headers: authHeader(),
          params: {
            type: selectedType,
            dateRange: selectedDateRange,
            filter: search,
            page: currentPage,
            center: selectedCenter,
          },
        }
      );
      setTotalItems(response?.data?.count);
      setInvoiceLists(response?.data?.results);
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: error,
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setSalesLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [
    currentPage,
    selectedType,
    selectedDateRange,
    search,
    selectedCenter,
    tabChange,
  ]);

  useEffect(() => {
    axios
      .get(`${config.baseUrl}/inventory/center_list/`, {
        headers: authHeader(),
      })
      .then((response) => {
        setCenterList(response?.data);
        const employeeIds = response?.data?.map(
          (center) => center?.center?.employee_id
        );
        setCenterIds(employeeIds);
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: error,
          confirmButtonText: "Ok",
          icon: "error",
        });
      });
  }, []);

  const salesColumn = [
    {
      title: "Date",
      width: "10%",
      render: (record) =>
        record?.created_at
          ? new Date(record?.created_at).toISOString().slice(0, 10)
          : "",
    },
    {
      title: "Location",
      width: "10%",
      render: (record) => record?.center?.center_name,
    },
    {
      title: "Customer Type",
      dataIndex: "customer_type",
      width: "10%",
    },
    {
      title: "Customer",
      width: "10%",
      render: (record) =>
        record?.farmer?.name ||
        record?.retailer?.name ||
        record?.regular?.name ||
        record?.institutional?.institutional_buyer_name,
    },
    {
      title: "Phone",
      width: "10%",
      render: (record) =>
        "0" +
        (record?.retailer?.phone ||
          record?.farmer?.phone ||
          record?.regular?.phone ||
          record?.institutional?.institutional_buyer_phone),
    },

    // {
    //   title: (
    //     <div className="row">
    //       <div className="col-sm text-pending">Product</div>
    //       <div className="col-sm">Sale Quantity</div>
    //     </div>
    //   ),
    //   width: "18%",
    //   render: (record) => {
    //     if (record?.invoice_products) {
    //       return record.invoice_products.map((product, index) => (
    //         <div className="row" key={index}>
    //           <div
    //             className={`col-sm border rounded me-1 ${
    //               record?.invoice_products.length > 0 ? "mb-1" : "mb-0"
    //             }`}
    //           >

    //           </div>
    //           <div
    //             className={`col-sm border rounded me-1 ${
    //               record?.invoice_products.length > 0 ? "mb-1" : "mb-0"
    //             }`}
    //           >
    //             {product?.quantity?.toLocaleString()}
    //           </div>
    //         </div>
    //       ));
    //     }
    //     return null;
    //   },
    // },
    {
      title: (
        <div className="d-flex justify-content-center">Product & Sale Qty</div>
      ),
      render: (record) =>
        record?.invoice_products?.map((product, index) => (
          <div
            key={index}
            className="d-flex justify-content-around align-items-center px-3 py-2 mb-2 rounded"
            style={{
              backgroundColor: "#f8f9fa",
              border: "1px solid #e0e0e0",
            }}
          >
            <div className="fw-medium text-dark">
              {product?.product?.product_name}
            </div>

            <div className="text-dark">
              <span className="fw-semibold">
                {product?.quantity?.toLocaleString()}
              </span>
            </div>
          </div>
        )),
      width: "18%",
    },
    {
      title: "Total",
      render: (record) =>
        Number(record?.total_price?.toFixed(2)).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
      width: "10%",
    },
    {
      title: "Action",
      key: "actions",
      width: "5%",
      render: (record) => (
        <>
          <Button
            className="px-5"
            onClick={() => handleBill(record)}
            style={{
              backgroundColor: "#46604A",
              borderColor: "#46604A",
              color: "white",
              opacity: 0.6,
            }}
          >
            View Bill
          </Button>
        </>
      ),
    },
  ];

  return (
    <>
      {visible && (
        <SalesBillTemplate
          visible={visible}
          modalClose={handleCancel}
          data={selectedRecord}
        />
      )}
      <div className="farmerDashboard">
        <div className="shadow-sm p-3">
          <div className="m-2 mt-4 d-flex justify-content-between align-items-center">
            <div>
              {centerIds?.includes(userProfile?.employee_id) ? null : (
                <Select
                  placeholder="Select Center"
                  className="me-3"
                  onChange={handleCenter}
                  style={{ width: "200px" }}
                >
                  <Option value="">All Center</Option>
                  {centerList?.map((center) => (
                    <Option
                      value={center?.center?.employee_id}
                      key={center?.center?.employee_id}
                    >
                      {center?.center_name}
                    </Option>
                  ))}
                </Select>
              )}
              <RangePicker
                onChange={handleSalesDateRage}
                value={
                  selectedDateRange
                    ? selectedDateRange.map((date) => dayjs(date))
                    : null
                }
                style={{ width: "320px" }}
              />
            </div>
            <Search
              className="w-25"
              placeholder="search here..."
              allowClear
              onSearch={handleSearch}
              enterButton={
                <Button
                  style={{
                    backgroundColor: "#46604A",
                    borderColor: "#46604A",
                    color: "white",
                  }}
                >
                  Search
                </Button>
              }
            />
          </div>
          <Table
            columns={salesColumn}
            dataSource={invoiceLists}
            loading={salesLoading}
            rowKey={(record) => record?.sales_id}
            size="small"
            pagination={{
              current: currentPage,
              pageSize: 10,
              total: totalItems,
              onChange: handlePageChange,
            }}
          />
        </div>
      </div>
    </>
  );
}
